﻿import $ from "jquery";
import LogoWidgetCarousel from "./LogoWidgetCarousel";
import LogoWidgetStandalone from "./LogoWidgetStandalone";

export default function create(ep, model) {
	
	const $ep = $(`#${ep}`);

	if ($ep.length) {
		switch (model.settings.layout) {
			case "standalone":
				return new LogoWidgetStandalone($ep, model);

			default:
				return new LogoWidgetCarousel($ep, model);
		}
	}
}
